import { render, staticRenderFns } from "./Pecuarios.vue?vue&type=template&id=46d7769b"
import script from "./Pecuarios.vue?vue&type=script&lang=js"
export * from "./Pecuarios.vue?vue&type=script&lang=js"
import style0 from "./Pecuarios.vue?vue&type=style&index=0&id=46d7769b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports